// const env = "onPremDev"; // This const MUST ALWAYS be on line 1. Overwritten by k8 on startup. Refer to package.json start script
const k8sConfig = typeof window === "undefined" ? require("config") : "";

let env = ""; // This const MUST ALWAYS be on line 1. Overwritten by k8 on startup. Refer to package.json start script
if (typeof window === "undefined") {
  env = k8sConfig.get("vodacom.baseenv");
} else {
  let host = window && window.location.hostname.toLowerCase();
  if (host.includes("local")) {
    env = "onPremQA";
  } else if (host.includes("webdev-stream-two")) {
    env = "onPremDev";
  } else if (host.includes("webdev-stream-four")) {
    env = "onPremDev";
  } else if (host.includes("dev")) {
    env = "onPremDev";
  } else if (host.includes("qa")) {
    env = "onPremQA";
  } else if (host.includes("stg")) {
    env = "onPremStage";
  } else {
    env = "Prod";
  }
}

const tempPort = 7700;
const proxy = "http://username:password@vfproxy.vodacom.corp:80/";

const config = {
  // TODO: Need to split config between client and server. Browser should not get config of upstream API's that are being proxied by the Node server.
  env: `${env}`,
  envConfigs: {
    dev: {
      port: tempPort,
      server: `http://localhost:${tempPort}`,
      serverDomain: `http://localhost:${tempPort}`,
      cookieDomain: "localhost",
      headerfooterUrlRoot: "https://wwwdev.vodacom.co.za",
      paymentCallback: `http://localhost:${tempPort}/shopping/checkout`,
      postPaymentCallback: `http://localhost:${tempPort}/shopping/post-checkout`,
      paymentProvision:
        "https://wwwdev.vodacom.co.za/cloud/rest/v1/product-ordering-management/provision",
      graphql: {
        url: "https://shopqa.vodacom.co.za/graphql",
        proxy: proxy,
      },
      restApi: {
        url: "https://shopqa.vodacom.co.za/rest",
        proxy: proxy,
        cloudApi: "https://wwwqa.vodacom.co.za/cloud/api"
      },
      drupalApi: {
        url: "https://wwwqa.vodacom.co.za",
        proxy: proxy,
        auth: "dnNzLmhlYWRsZXNzLmZvcm0udXNlcjpYNkxpSjJuTDUwZDlQNHlLTTVuSw==",
      },
      dxl: {
        url: "/dxl",
        proxyUrl: "https://apiqa.vodacom.co.za",
        proxy: null,
      },
      DIDLoginUrl: "https://wwwdev.vodacom.co.za/cloud/digital/login",
      DIDRegisterUrl: "https://wwwdev.vodacom.co.za/cloud/digital/registration",
      imagePrefix: "/public",
      shoppingUrlPrefix: "/shopping",
      vodaComTermUrlPrefix: "/vodacom/terms",
      legacyEnv: "dev",
      helpText: "helpText",
      featureBaseUrl: "/shopping/api/features",
      vodapay: {
        clientId: '2020122325111778413994',
        userId: '216610000000549759346',
        useApplyAuthCode: true
      },
      miniAppUrl: 'https://vodminiapps.nonprod.vodacom.co.za/sales/index.html'
    },
    onPremDev: {
      port: 8080,
      server: `https://wwwdev.vodacom.co.za`, // `http://localhost:${tempPort}`
      serverDomain: "https://wwwdev.vodacom.co.za", // Setting QA to fetch drupal QA config
      cookieDomain: ".vodacom.co.za",
      // sslKey: "ec2dev.key",
      // sslCert: "ec2dev.cert",
      headerfooterUrlRoot: "https://wwwdev.vodacom.co.za",
      paymentCallback: "https://wwwdev.vodacom.co.za/shopping/checkout",
      postPaymentCallback:
        "https://wwwdev.vodacom.co.za/shopping/post-checkout",
      paymentProvision:
        "https://apidev.vodacom.co.za/web/payment/v1/handlePayment",
      graphql: {
        url: "https://shopdev.vodacom.co.za/graphql", /*changing to shopdev temporarily for testing*/
        proxy: "http://vod-ms-egress-proxy:3128",
      },
      restApi: {
        url: "https://shopdev.vodacom.co.za/rest",
        proxy: "http://vod-ms-egress-proxy:3128",
        cloudApi: "https://wwwdev.vodacom.co.za/cloud/api"
      },
      drupalApi: {
        url: "https://wwwdev.vodacom.co.za",
        proxy: "http://vod-ms-egress-proxy:3128",
        auth: "dnNzLmhlYWRsZXNzLmZvcm0udXNlcjpYNkxpSjJuTDUwZDlQNHlLTTVuSw==",
      },
      dxl: {
        url: "https://apidev.vodacom.co.za",
        proxy: null,
      },
      DIDLoginUrl: "https://wwwdev.vodacom.co.za/cloud/digital/login",
      DIDRegisterUrl: "https://wwwdev.vodacom.co.za/cloud/digital/registration",
      imagePrefix: "/public",
      shoppingUrlPrefix: "/shopping",
      vodaComTermUrlPrefix: "/vodacom/terms",
      legacyEnv: "dev",
      helpText: "helpText",
      featureBaseUrl: "/shopping/api/features",
      vodapay: {
        clientId: '',
        userId: '',
        useApplyAuthCode: false
      },
      miniAppUrl: 'https://vodminiapps.nonprod.vodacom.co.za/sales/index.html',
      redux: {
        enableLogger: true,
      }
    },
    onPremQA: {
      port: 8080,
      server: "https://wwwqa.vodacom.co.za",
      serverDomain: "https://wwwqa.vodacom.co.za",
      cookieDomain: ".vodacom.co.za",
      headerfooterUrlRoot: "https://wwwqa.vodacom.co.za",
      // sslKey: "ec2dev.key",
      // sslCert: "ec2dev.cert",
      paymentCallback: "https://wwwqa.vodacom.co.za/shopping/checkout",
      postPaymentCallback: "https://wwwqa.vodacom.co.za/shopping/post-checkout",
      paymentProvision:
        "https://apiqa.vodacom.co.za/web/payment/v1/handlePayment",
      graphql: {
        url: "https://shopqa.vodacom.co.za/graphql",
        proxy: "http://vod-ms-egress-proxy:3128",
      },
      restApi: {
        url: "https://shopqa.vodacom.co.za/rest",
        proxy: "http://vod-ms-egress-proxy:3128",
        cloudApi: "https://wwwqa.vodacom.co.za/cloud/api"
      },
      drupalApi: {
        url: "https://wwwqa.vodacom.co.za",
        proxy: "http://vod-ms-egress-proxy:3128",
        auth: "dnNzLmhlYWRsZXNzLmZvcm0udXNlcjpYNkxpSjJuTDUwZDlQNHlLTTVuSw==",
      },
      dxl: {
        url: "https://apiqa.vodacom.co.za",
        proxy: null,
      },
      DIDLoginUrl: "https://wwwqa.vodacom.co.za/cloud/digital/login",
      DIDRegisterUrl: "https://wwwqa.vodacom.co.za/cloud/digital/registration",
      imagePrefix: "/public",
      shoppingUrlPrefix: "/shopping",
      vodaComTermUrlPrefix: "/vodacom/terms",
      legacyEnv: "qa",
      helpText: "helpText",
      featureBaseUrl: "/shopping/api/features",
      vodapay: {
        clientId: '',
        userId: '',
        useApplyAuthCode: false
      },
      miniAppUrl: 'https://vodminiapps.nonprod.vodacom.co.za/sales/index.html',
      redux: {
        enableLogger: true,
      }
    },
    onPremStage: {
      port: 8080,
      server: "https://wwwstg.vodacom.co.za",
      serverDomain: "https://wwwstg.vodacom.co.za",
      cookieDomain: ".vodacom.co.za",
      headerfooterUrlRoot: "https://wwwstg.vodacom.co.za",
      // sslKey: "ec2dev.key",
      // sslCert: "ec2dev.cert",
      paymentCallback: "https://wwwstg.vodacom.co.za/shopping/checkout",
      postPaymentCallback:
        "https://wwwstg.vodacom.co.za/shopping/post-checkout",
      // https://apistg.vodacom.co.za/web/payment/v1/provision
      paymentProvision:
        "https://apistg.vodacom.co.za/web/payment/v1/handlePayment",
      graphql: {
        url: "https://shopstg.vodacom.co.za/graphql",
        proxy: "http://vod-ms-egress-proxy:3128",
      },
      restApi: {
        url: "https://shopstg.vodacom.co.za/index.php/rest",
        proxy: "http://vod-ms-egress-proxy:3128",
        cloudApi: "https://wwwstg.vodacom.co.za/cloud/api"
      },
      drupalApi: {
        url: "https://wwwstg.vodacom.co.za",
        proxy: "http://vod-ms-egress-proxy:3128",
        auth: "dnNzLmhlYWRsZXNzLmZvcm0udXNlcjpYNkxpSjJuTDUwZDlQNHlLTTVuSw==",
      },
      dxl: {
        url: "https://apistg.vodacom.co.za",
        proxy: null,
      },
      DIDLoginUrl: "https://wwwstg.vodacom.co.za/cloud/digital/login",
      DIDRegisterUrl: "https://wwwstg.vodacom.co.za/cloud/digital/registration",
      imagePrefix: "/public",
      shoppingUrlPrefix: "/shopping",
      vodaComTermUrlPrefix: "/vodacom/terms",
      legacyEnv: "stg",
      helpText: "helpTextStg",
      featureBaseUrl: "/shopping/api/features",
      vodapay: {
        clientId: '',
        userId: '',
        useApplyAuthCode: false
      },
      miniAppUrl: 'https://vodminiapps.nonprod.vodacom.co.za/sales/index.html'
    },
    Prod: {
      port: 8080,
      server: "https://www.vodacom.co.za",
      serverDomain: "https://www.vodacom.co.za",
      cookieDomain: ".vodacom.co.za",
      headerfooterUrlRoot: "https://www.vodacom.co.za",
      // sslKey: "ec2dev.key",
      // sslCert: "ec2dev.cert",
      paymentCallback: "https://www.vodacom.co.za/shopping/checkout",
      postPaymentCallback: "https://www.vodacom.co.za/shopping/post-checkout",
      paymentProvision: "https://api.vodacom.co.za/web/payment/v1/handlePayment",
      graphql: {
        url: "https://shop.vodacom.co.za/graphql",
        proxy: "http://vod-ms-egress-proxy:3128",
      },
      restApi: {
        url: "https://shop.vodacom.co.za/index.php/rest",
        proxy: "http://vod-ms-egress-proxy:3128",
        cloudApi: "https://www.vodacom.co.za/cloud/api"
      },
      drupalApi: {
        url: "https://www.vodacom.co.za",
        proxy: "http://vod-ms-egress-proxy:3128",
        auth: "dnNzLmhlYWRsZXNzLmZvcm0udXNlcjpYNkxpSjJuTDUwZDlQNHlLTTVuSw==",
      },
      dxl: {
        url: "https://api.vodacom.co.za",
        proxy: null,
      },
      DIDLoginUrl: "https://www.vodacom.co.za/cloud/digital/login",
      DIDRegisterUrl: "https://www.vodacom.co.za/cloud/digital/registration",
      imagePrefix: "/public",
      shoppingUrlPrefix: "/shopping",
      vodaComTermUrlPrefix: "/vodacom/terms",
      legacyEnv: "",
      helpText: "helpTextProd",
      featureBaseUrl: "/shopping/api/features",
      vodapay: {
        clientId: '',
        userId: '',
        useApplyAuthCode: false
      },
      miniAppUrl: 'https://vodminiapps.prod.vodacom.co.za/sales/index.html'
    },
  },
  dev: process.env.NODE_ENV !== "production",
  drupalBaseUrl: "/drupalApi",
  apiBaseUrl: "http://dummy.restapiexample.com/api/v1",
  graphqlUrl: "/graphql",
  restUrl: "/dxl",
  addressSearchBaseUrl: "/addressApi",
  featureBaseUrl: "/shopping/api/features",
  stub: {
    getProdListMetaData: "productMetaData.json",
    getMainMenuMetaData: "mainMenuMetaData.json",
    getGlobalNavMetaData: "globalNavMetaData.json",
  },
  api: {
    getProdListMetaData: "/products/2c6db31d-6773-428e-b937-9d4ccf7ac75c",
    getHomePage: "/home-page/0d9304ac-af10-46a5-8a08-4d62340b8072",
    getMainMenuMetaData: "/cms-api/main-menu",
    getGlobalNavMetaData: "/cms-api/global-navigation",
    getPage: "/cms-api/page",
    searchQuickLinks: "/cms-api/search-quick-links-api?_format=json",
    getBundles: "/cms-api/get-bundles",
    bundleDeals: "/cms-api/deal/bundles",
    helpText: "/cms-api/help-text/926",
    helpTextStg: "/cms-api/help-text/516",
    helpTextProd: "/cms-api/help-text/516",
    internationalCalling: "/cms-api/international-calling-page",
    addressSearch:
      "/sedirectory_2/services/geocode/v2/address?ils_location=446 RigelAvenue,Erasmusrand&indent=true&ils_groups=address_component&ils_groups=metadata",
    preOrderFormDetails:
      "/cms-api/webform_rest/pre_launch_form/fields?_format=json",
    preOrderSubmit: "/cms-api/webform_rest/submit",
    preOrderCsrfToken: "/cms-api/rest/session/token",
    addressSearchDev:
      "/vod-ms-location-management/restricted-cluster-only-services/v2/geocode/address",
    profileSync: "/web/auth/rest/services/v4/login/ecom",
    profileUpdate: "/web/ecom/rest/cbu/V1/vodacom/login",
    dealSelectionData: "/cms-api/commerce-data-api",
    dealSelectionMinutes: "/cms-api/commerce-minutes-api",
    contactUsPage: "/cms-api/contact-us-page/contact-us/CBU",
    contactUsPagePreview: "/cms-api/contact-us-page/contact-us/CBU/0",
    contactUsSubcategories: "/cms-api/contactUs/subCategories",
    contactUsCards: "/cms-api/contactUs/cards",
    addressDev: "/web/location/v2/location/geocode/address",
    postpaidProductOrder: "/web/ecom/product-ordering/v1/productOrder",
    verifyPayment: "/web/payment/v1/verify",
    search: "/web/search/v1/search?searchText=",
    searchNoResult: "/cms-api/page/search-no-results/CBU",
    searchNoResultPreview: "/cms-api/page/search-no-results/CBU/0",
    getMethodGraphQL: "/web/ecom/v1/graphql",
    postMethodGraphQL: "/web/ecom/v1/graphql/product",
    getCovidBannerConfig: "/sites/default/files/2021-01/menuconfig.json",
    cartValidationAddOnceOffError:
      "/cms-api/commerce-result-code/CartValidation_AddOnceOff_Error",
    cartValidationAddDealError:
      "/cms-api/commerce-result-code/CartValidation_AddDeal_Error",
    formCsrfToken: "/cms-api/rest/session/token",
    userTesterFormDetails:
      "/cms-api/webform_rest/sign_up_form_user_tester/fields?_format=json",
    betaTesterFormDetails:
      "/cms-api/webform_rest/sign_up_form_beta_tester/fields?_format=json",
    dynamicFormSubmit: "/cms-api/webform_rest/submit",
    staticFormSubmit: "/web/vetting-manage/customers/leads",
    checkoutFaq: "/cms-api/page/checkout-journey/CBU",
    checkoutPath: "/cms-api/page/delivery-details/CBU",
    paidDeliveryCheckoutPath: '/cms-api/page/delivery-details-paid/CBU',
    numberTransferPage: "/cms-api/page/transfer-number-info/CBU",
    loadLookup:
      "/web/vetting-manage/public-services/vetting/manage/loadlookups",
    customerInformation:
      "/web/product-offering-qualification/vetting/customers/{reqParams}/msisdns",
    preValidation: "/web/vetting/vetting/customers/{reqParams}/validate",
    geoGraphicSiteStock: "/web/location/v1/location/findwithstock",
    getCords: "/web/location/v1/Spatial-Exchange/geocode/address",
    questionsAndAnswers:
      "/web/subscriber/authentication/retrieveQuestionsAndAnswers/{reqParams}",
    submitXdsAnswers: "/web/subscriber/authentication/submitXDSAnswers",
    mergeCartError: "/cms-api/commerce-result-code/merge_cart_error",
    errorResultDetails: "/cms-api/commerce-result-code",
    upgradeEligibleCheck: "/cms-api/page/upgrade-eligible-check-page/CBU",
    //upgrade
    oneTimePin: "/web/otp/vetting/{reqParams}",
    oneTimePinv2: "/web/otp/generate/onetimepins/PORT_IN/{reqParams}",
    oneTimePinEligible: "/web/otp/rest/v1/onetimepins/PORT_IN/{reqParams}",
    validatePhoneForPrepaidNumber:
      "/web/ecom/customer/rest/services/web/customer/msisdn/{reqParams}/details",
    portInValidation:
      "/web/ecom/customer/customers/customerinteraction/{reqParams}",
    getAllEligibility: "/web/product-offering-qualification/v1/all/eligible",
    getMSIDNForAuthentication: "/web/ecom/customer/{reqParams}/upgradeMsisdns",
    generateOtp: "/web/otp/vetting/generateOtp",
    getEligibilityForAlternativeNumbers:
      "/web/product-offering-qualification/v1/eligible/numbers/alternate",
    eligibilityForLinkedNumbersList:
      "/web/product-offering-qualification/v1/eligible/numbers/linked",
    upgradeResult: "/cms-api/commerce-result-code",
    UnprocessedVettingResult:
      "/cms-api/commerce-result-code/Unprocessed_Vetting_Result",
    DeclinedNonNXTLVL: "/cms-api/commerce-result-code/Declined_Non-NXT_LVL",
    creditCheckConsent: "/cms-api/page/credit-check-consent/CBU",
    createCustomer: "/web/ecom/customer/customers/{reqParams}/information",
    customerDetails: "/web/ecom/customer/v1/customerDetails",
    pastUsage: "/web/ecom/customer/rest/services/past-usage",
    lookupData: "/web/devices/rest/service/lookup-device-data",
    upgradeDeviceModels: "/web/devices/v1/devices/models",
    getRecommendedDeals: "/web/product-offering/deals/getAllRecommendedDeals",
    consumption: "/cloud/rest/services/web/customer/consumption",
    validateBankDetails:
      "/web/vetting-manage/customers/{reqParams}/accounts/validate",
    creditFilters:
      "/web/ecom/customer/{reqParams}/creditFilters?field=creditProfile&idType=MSISDN",
    creditVettingOutcome: "/web/sales-order-fulfillment/v1/credit/vetting",
    authenticateAlternativeNumber:
      "/web/otp/vetting/authenticateAlternativeNumber",
    dealDetailsUnaffordabilityError:
      "/cms-api/commerce-result-code/Deal_Details_Unaffordability_Error",
    upgradeLegacySwitch: "/cms-api/legacy-switch",
    headerFragment: "/fragment-header",
    footerFragment: "/old-fragment-footer",
    getOrderShippingStatus: "/web/ecom/ecom/order/shipping/status/{reqParams}",
    getOrderVettingStatus: "/cms-api/commerce-result-code/{reqParams}",
    getOrderStatusStatic: "/cms-api/page/order-tracking-vetting-status/CBU",
    features: "/features-check",
    getVASDeatilsForDeals: "/web/ecom/v1/getVAS",
    pendedReferredSplitMessage:
      "/cms-api/page/pended-referred-order-split-message/CBU",
    offlineSplitMessage:
      "/cms-api/page/multi-cart-unprocessed-vetting-split-text/CBU",
    storeStockCheckStatus:
      "/cms-api/page/store-stock-check-online-postpaid/CBU",
    contractCover: "/cms-api/page/deal-cart-page-vas-text/CBU",
    shoppingCartEmpty: "/cms-api/page/shopping-cart-empty-text/CBU",
    preOrderProductInfo: "/cms-api/page/pre-order-product-info/CBU",
    preOrderProductDetail: "/cms-api/page/pre-order-product-details-info/CBU",
    preOrderDealDetail: "/cms-api/page/pre-order-deal-details-info/CBU",
    paymentOptionsData: "/cms-api/page/payment-option-description-page/CBU",
    paymentStoredCardsData:
      "/web/ecom/product-ordering/v1/paymentMethods/paymentMethod",
    deleteStoredCard:
      "/web/ecom/product-ordering/v1/paymentMethods/paymentMethod/{reqParams}",
    getMiniAppPaymentUrl: "/web/ecom/product-ordering/v1/customerPayment/vodaPay",
  },
  pageServiceQueryData: {
    site: "CBU",
    status: "",
    preview: "/0",
  },
  paymentConfig: {
    paymentGatewayBaseUrl: "",
    paymentGatewayUrl: "",
    payServerUser: "",
    transactionStatusCallbackFormat: "",
    transactionStatusCallbackMethod: "",
    merchantReference: "",
    currency: "",
    transactionType: "",
    merchantIdentifier: "",
    customerIdentifier: "",
    encType: "",
  },
  buyOptions: [
    {
      label: "Buy this product once-off",
      name: "once-off",
    },
    {
      label: "Get this product on a new contract",
      name: "on-contract",
    },
    {
      label: "Upgrade",
      name: "upgrade",
    },
  ],
  dealBuyOptions: [
    {
      label: "Get this deal on a new contract",
      name: "new-contract",
    },
    {
      label: "Upgrade",
      name: "upgrade",
    },
  ],
  order_id: "order_id",
  pay_fail_count: "pay_fail_count",
  cookie_category: {
    strictly_necessary: "C0001",
    performance: "C0002",
    functional: "C0003",
    targeted: "C0004",
    social_media: "C0005",
  },
  maxRetriesCount: 3,
  legacyAllowed: false,
  collectAtStore: true,
  miniApp: {
    paymentCallback: '/shopping/checkout',
    postPaymentCallback: '/shopping/post-checkout'
  }
};

config.EnvConfig = config.envConfigs[env];

module.exports = config;
